import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fe56394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-header" }
const _hoisted_2 = { class: "form-header-box" }
const _hoisted_3 = {
  key: 0,
  class: "part"
}
const _hoisted_4 = { class: "form-desc" }
const _hoisted_5 = { key: 0 }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["form-name", _ctx.formName.line1 ? 'two-lines' : ''])
      }, [
        (_ctx.formName.line1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formName.line1), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["letter", _ctx.formName.line1 ? '' : 'sml'])
        }, _toDisplayString(_ctx.formName.line2), 3)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.formDesc.line1), 1),
        (_ctx.formDesc.line2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.formDesc.line2), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}